import { render, staticRenderFns } from "./PDF_Price_2.vue?vue&type=template&id=4e5c537b&scoped=true"
import script from "./PDF_Price_2.vue?vue&type=script&lang=js"
export * from "./PDF_Price_2.vue?vue&type=script&lang=js"
import style0 from "./PDF_Price_2.vue?vue&type=style&index=0&id=4e5c537b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5c537b",
  null
  
)

export default component.exports